
import {ref, defineComponent, onBeforeUnmount, onMounted, PropType} from 'vue';

import {AccordionDataGroup} from './types';

export default defineComponent({
  name: 'Accordion',

  props: {
    list: {type: Array as PropType<AccordionDataGroup[]>, required: true}
  },

  emits: ['change'],

  setup(props, {emit}) {
    // 组件高度
    const scrollWrapperHeight = ref(0);
    // 主列表项已展开的索引
    const expandedIndex = ref(0);
    // 子列表项被选中的索引(分类组索引-子分类索引)
    const selectedId = ref('0-0');
    // 组件根元素引用
    const el = ref(null as unknown as HTMLElement);
    // 组件根元素Resize观察者
    let resizeObserver: ResizeObserver | null;

    onMounted(() => {
      // 当根元素宽高发生变化时,回调此方法以计算滚动盒子内部高度
      resizeObserver = new ResizeObserver(([entry]) => {
        // 获取组件根节点 和 组件根节点的高度
        let node = entry.target as HTMLElement, height = node.offsetHeight;
        // 获取所有标题层子节点
        let nodes = node.querySelectorAll<HTMLElement>('.list-view .titled-pane');
        // 滚动高度 = 根节点高度 - 所有标题层子节点高度
        nodes.forEach(node => height -= node.offsetHeight);
        // 设置滚动高度
        scrollWrapperHeight.value = height;
      });

      // 观察根节点大小变化
      resizeObserver.observe(el.value);
    });

    onBeforeUnmount(() => {
      if (resizeObserver != null) {
        resizeObserver.unobserve(el.value);
        resizeObserver.disconnect();
        resizeObserver = null;
      }
    });

    return {
      el, scrollWrapperHeight, expandedIndex, selectedId,

      /**
       * ListView被点击时触发
       *
       * @param event 指针事件
       * @param data 所点击对应的数据项
       * @param index 所点击对应的数据项索引
       */
      onClick: (event: PointerEvent, data: AccordionDataGroup, index: number) => {
        event.stopPropagation();

        const node = event.target as HTMLElement;
        const dataIndex = node.getAttribute('data-index');

        if (dataIndex) {
          const itemIndex = Number(dataIndex);
          const newId = `${index}-${itemIndex}`;

          if (selectedId.value !== newId) {
            selectedId.value = newId;
            emit('change', data.items[itemIndex], data, index);
          }

        } else {
          // 若当前分类组已被展开,那么折叠它, 否则展开它
          expandedIndex.value = expandedIndex.value === index ? -1 : index;
        }
      }

    };
  }
});
